import { render, staticRenderFns } from "./WarehouseTransferDetails.vue?vue&type=template&id=675250c6&"
import script from "./WarehouseTransferDetails.vue?vue&type=script&lang=js&"
export * from "./WarehouseTransferDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports